export default "__VITE_ASSET__Cea985Hw__"